import { provideApolloClient } from '@vue/apollo-composable'
import { createApolloClient } from '~/composables/createApolloClient/index'

export default defineNuxtPlugin((nuxtApp) => {
  const apolloClient = createApolloClient()

  provideApolloClient(apolloClient)
  nuxtApp.vueApp.use(apolloClient)
})
